import constant from "./constant";

let Actions = {
  addBrandsList: (data) => {
    return {
      type: constant.ADD_BRANDS_LIST,
      payload: data,
    };
  },
  updateSliderList: (data) => {
    return {
      type: constant.UPDATE_SLIDER_LIST,
      payload: data,
    };
  },
  brandsLoading: (data) => {
    return {
      type: constant.BRANDS_LOADING,
      payload: data,
    };
  },
  // ******************************************************
  addCategoryList: (data) => {
    return {
      type: constant.ADD_CATEGORY_LIST,
      payload: data,
    };
  },
  categoryLoading: (data) => {
    return {
      type: constant.CATEGORY_LOADING,
      payload: data,
    };
  },
  // ******************************************************* 
  addGalleryList: (data) => {
    return {
      type: constant.ADD_GALLERY_LIST,
      payload: data,
    };
  },
  addGallery: (data) => {
    return {
      type: constant.ADD_GALLERY,
      payload: data,
    };
  },
  // ******************************************************* 
  addUsersList: (data) => {
    return {
      type: constant.ADD_USERS_LIST,
      payload: data,
    };
  },
  usersLoading: (data) => {
    return {
      type: constant.USERS_LOADING,
      payload: data,
    };
  },
  // *******************************************************
  addPendingList: (data) => {
    return {
      type: constant.ADD_PENDING_LIST,
      payload: data,
    };
  },
  pendingLoading: (data) => {
    return {
      type: constant.PENDING_LOADING,
      payload: data,
    };
  },
  newOrderRevived: (data) => {
    return {
      type: constant.NEW_ORDER_RECEIVED,
      payload: data,
    };
  },
  // *******************************************************
  profileLoading: (data) => {
    return {
      type: constant.PROFILE_LOADING,
      payload: data,
    };
  },
  addProfile: (data) => {
    return {
      type: constant.ADD_PROFILE,
      payload: data,
    };
  },
  updatePlugin: (data) => {
    return {
      type: constant.UPDATE_PLUGIN,
      payload: data,
    };
  },
  // *******************************************************
  productLoading: (data) => {
    return {
      type: constant.PRODUCT_LOADING,
      payload: data,
    };
  },
  addProductsList: (data) => {
    return {
      type: constant.ADD_PRODUCT_LIST,
      payload: data,
    };
  },
  addProduct: (data) => {
    return {
      type: constant.ADD_PRODUCT,
      payload: data,
    };
  },
  // *******************************************************
  ordersLoading: (data) => {
    return {
      type: constant.ORDERS_LOADING,
      payload: data,
    };
  },
  addOrdersList: (data) => {
    return {
      type: constant.ADD_ORDERS_LIST,
      payload: data,
    };
  },
  addOrder: (data) => {
    return {
      type: constant.ADD_ORDER,
      payload: data,
    };
  },
  // *******************************************************
  contactUsLoading: (data) => {
    return {
      type: constant.CONTACT_US_LOADING,
      payload: data,
    };
  },
  addContactUsList: (data) => {
    return {
      type: constant.ADD_CONTACT_US_LIST,
      payload: data,
    };
  },
  // *******************************************************
  locationsLoading: (data) => {
    return {
      type: constant.LOCATIONS_LOADING,
      payload: data,
    };
  },
  addLocationsList: (data) => {
    return {
      type: constant.ADD_LOCATIONS_LIST,
      payload: data,
    };
  },
  addLocation: (data) => {
    return {
      type: constant.ADD_LOCATION,
      payload: data,
    };
  },
  // ***********************************************
  updateBlockedAppStatus: (data) => {
    return {
      type: constant.UPDATE_BLOCKED_APP_STATUS,
      payload: data,
    };
  },
  // ***********************************************
  dashboardLoading: (data) => {
    return {
      type: constant.DASHBOARD_LOADING,
      payload: data,
    };
  },
  updateDashboard: (data) => {
    return {
      type: constant.UPDATE_DASHBOARD,
      payload: data,
    };
  },

}
export default Actions

